var Moment = function (time) {
    this.time = new Date(time);
}

var fixNumber  = function(n){
    if(n.toString().length<2){
        return "0"+n;
    }
    return n;
}
Moment.prototype = {
    fromNow: function () {
        var now = new Date();

        if (now - this.time <= 10 * 60 * 1000) {
            //10 分钟
            return "刚刚"
        }
        else if (now - this.time <= 60 * 60 * 1000) {
            //60分钟内
            return Math.round((now - this.time) / 60 / 1000) + "分钟前";
        }
        else if (now - this.time <= 24 * 60 * 60 * 1000) {
            //24 小时内
            return Math.round((now - this.time) / 60 / 60 / 1000) + "小时前";
        } else if (now.getFullYear() == this.time.getFullYear()) {

            return fixNumber(this.time.getMonth() + 1) + "-" + fixNumber(this.time.getDate()) + " " + fixNumber(this.time.getHours()) + ":" + fixNumber(this.time.getMinutes());
        } else {
            return this.time.getFullYear() + "-" + fixNumber(this.time.getMonth() + 1) + "-" + fixNumber(this.time.getDate());
        }
    },
    format: function (format_str) {
        return format_str.replace("yyyy", this.time.getFullYear())
            .replace("MM", fixNumber(this.time.getMonth() + 1))
            .replace("dd", fixNumber(this.time.getDate()))
            .replace("HH", fixNumber(this.time.getHours()))
            .replace("mm", fixNumber(this.time.getMinutes()))
            .replace("ss", fixNumber(this.time.getSeconds()))
    },
    fixTime: function () {
        var now = new Date();
        //the same year
        if (now.getFullYear() == this.time.getFullYear()) {

            var n = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var c = new Date(this.time.getFullYear(), this.time.getMonth(), this.time.getDate());
            if (n - c == 0) {
                return "今天 " + fixNumber(this.time.getHours()) + ":" + fixNumber(this.time.getMinutes());
            }
            else if (n - c <=  24 * 60 * 60 * 1000) {
                return "昨天 " + fixNumber(this.time.getHours()) + ":" + fixNumber(this.time.getMinutes());
            }
            else {
                return this.fromNow();
            }
        }
        //different year
        else {
            return this.fromNow();
        }
    }
}
export default Moment;